import React, { useEffect, useState, useRef } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { drawPicker } from "../popovers/Picker";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Divider from "../ui/Divider";
import Input from "../ui/Input";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { addISBNDashes, showHelp } from "../utils/Utils";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { ROUTES } from "../utils/Routes";
import GLAccounts from "./GLAccounts";
import { createModal } from "../hooks/createModal";


export default function SetupTaxTypesNew(props) {

    const { controller = "", type = { code: "", name: "", rate: "", gl_account: "", points_coupons: "" }, edit = false, groups = [], types = [], route = "", callback = () => { } } = props;

    const codes = types.map(item => { return { label: item.code, value: item.code } });

    const refs = useRef([]);

    const [index, setIndex] = useState("code");


    const [tabs, setTabs] = useState([
        { key: "code", value: type.code },
        { key: "name", value: type.name },
        { key: "rate", value: type.rate },
        { key: "gl_account", value: type.gl_account },
        { key: "points_coupons", value: type.points_coupons },
    ])

    const update = (_key, value) => {
        let _t = [...tabs];
        setTabs(_t.map(tab => tab.key === _key ? { ...tab, value: value } : tab)
        );
    }

    const getVal = (_key) => {
        return tabs.find(item => item.key === _key).value
    }

    const status = {
        code: <>PgUp for Help</>,
        name: <>PgUp for Help</>,
        rate: <>PgUp for Help</>,
        gl_account: <>PgUp for Help</>,
        points_coupons: <>PgUp for Help</>,
    }

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: true,
        controlled: true,
        autoselect: true,
        onChange: (e) => update(index, e)
    });

    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };

    const onEnter = () => {
        switch (index) {
            case "gl_account":
                drawGLAccounts(getVal("gl_account"));
                break;
        }
    }

    const onPageUp = () => {
        switch (index) {
            case "gl_account":
                drawGLAccounts(getVal("gl_account"));
                break;
        }
    }

   
    const save = () => {

        let _info = { 
            code: getVal("code"), 
            name: getVal("name"), 
            rate: parseFloat(getVal("rate")) || 0, 
            gl_account: getVal("gl_account"), 
            gl_description: "", 
            points_coupons: getVal("points_coupons") 
        }

        if(!_info.code){
            showError({error : "Code required"});
            return; 
        }

        if(!_info.gl_account){
            showError({error : "GL account required"});
            return; 
        }

        let _api = "setting.tax.createType";
        let _params = {info : _info};
        if(edit){
            _api = "setting.tax.editType";
            _params = {info : _info, original_code : type.code};
        }

        pubCall(_api, _params, (_s, _r) => {
            if(_s){
                callback(_r);
            } else {
                showError(_r);
            }
        })
    }

    // Keyboard Events
    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }

        const actions = [
            { key: KBD.ARROW_DOWN, action: (e) => next() },
            { key: KBD.ARROW_UP, action: (e) => prev() },
            { key: KBD.TAB, action: (e) => { next() } },
            { key: KBD.SHIFT_TAB, action: (e) => { prev() } },
            { key: KBD.ESCAPE, action: (e) => callback(false) },
            { key: KBD.ENTER, action: (e) => { onEnter() } },
            { key: KBD.PAGE_UP, action: (e) => { onPageUp() } },
            { key: KBD.PAGE_DOWN, action: (e) => { save() } }
        ];
        const cleanup = listen(controller, route, actions, (e) => {
            if (e.deltaY > 0) {
                next();
            } else {
                prev();
            }
        }, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.CTRL_C, KBD.CTRL_V], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [index, tabs, update]);



    const drawGLAccounts = (_search) => {
        window.bm_state.value = ROUTES.GL.ACCOUNTS;
        refs.current["gl_account"].blur();
        createModal({
            component: <GLAccounts controller={controller} search={_search} route={ROUTES.GL.ACCOUNTS} />, title: "GL Accounts", closable: true, callback: (e) => {
                if (e) {
                    update("gl_account", e?.account);
                }
                refs.current["gl_account"].focus();
                window.bm_state.value = route;
            }
        })
    }




    return (<>
        <div className="shim" /><div className="shim" /><div className="shim" />
        <div style={{ "width": "320px" }}>
            <Space height={25} size={10}>
                <Label width={100}>Tax Code</Label><Divider vertical />
                <Input {...editProps("code")} lowercase maxLength={1} autoselect placeholder="" width={34} value={getVal("code")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Tax Name</Label><Divider vertical />
                <Input {...editProps("name")} maxLength={6} uppercase autoselect placeholder="" width={100} value={getVal("name")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Tax Rate</Label><Divider vertical />
                <Input {...editProps("rate")} decimal maxLength={6} autoselect placeholder="" width={100} value={getVal("rate")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>GL Account</Label><Divider vertical />
                <Input doubleclick={KBD.ENTER} {...editProps("gl_account")} lowercase maxLength={3} autoselect placeholder="" width={40} value={getVal("gl_account")} />
            </Space>
            <div className="shim" />
            <Space height={25} size={10}>
                <Label width={100}>Points Coupons</Label><Divider vertical />
                <Input doubleclick={KBD.ENTER} {...editProps("points_coupons")} lowercase maxLength={2} autoselect placeholder="" width={40} value={getVal("points_coupons")} />
            </Space>
            <div className="shim" />
            <div className="shim" />
            <div style={{ "textAlign": "center" }}><small className="label">Press <strong>{KBD.PAGE_DOWN.label}</strong> to save.</small></div>
            <div className="shim" /><div className="shim" />
            <Status><InfoIcon /> {status[index]}</Status>
        </div>

    </>)

}